module.exports = __webpack_public_path__ + "img/nullAddrIcon.2804c857.png";